import { render, staticRenderFns } from "./editexhibitionA.vue?vue&type=template&id=f9e25094&scoped=true&"
import script from "./editexhibitionA.vue?vue&type=script&lang=js&"
export * from "./editexhibitionA.vue?vue&type=script&lang=js&"
import style0 from "./editexhibitionA.vue?vue&type=style&index=0&id=f9e25094&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e25094",
  null
  
)

export default component.exports